import React, { useEffect, useState } from "react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const MOTIVOS = {
  bajo_umbral: "No se retiene: no supera el umbral de 10 jornales mínimos en el mes",
  constancia_exportador: "No se retiene: proveedor con constancia de exportador vigente",
  constancia_no_retencion: "No se retiene: proveedor con constancia de no retención vigente",
  sin_regla: "No se retiene: no hay regla para este comprobante/tasa",
  comprobante_exento: "No se retiene: comprobante sin IVA retenible",
  omitida_manual: "Retención omitida manualmente: el proveedor cobró el importe completo",
};

/**
 * Vista previa de la retención de IVA al pagar compras. Solo se muestra si la empresa es
 * agente de retención y hay algo para informar. pagos = [{compra_id, monto}].
 */
export default function RetencionPreview({ token, pagos, fechaPago, moneda = "PYG", excluirPagoProveedorId, omitir = false, onOmitir = null }) {
  const [res, setRes] = useState(null);
  const clave = JSON.stringify([pagos, fechaPago, excluirPagoProveedorId, omitir]);

  useEffect(() => {
    const validos = (pagos || []).filter(p => p.compra_id && Number(p.monto) > 0);
    if (!validos.length || !fechaPago) { setRes(null); return undefined; }
    const t = setTimeout(() => {
      fetch(`${API}/admin/retenciones/simular`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
        body: JSON.stringify({
          pagos: validos.map(p => ({ compra_id: p.compra_id, monto: Number(p.monto) })),
          fecha_pago: fechaPago,
          exclude_pago_proveedor_id: excluirPagoProveedorId || null,
          sin_retencion: !!omitir,
        }),
      })
        .then(r => (r.ok ? r.json() : null))
        .then(setRes)
        .catch(() => setRes(null));
    }, 350);
    return () => clearTimeout(t);
  }, [clave, token]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!res || !res.agente) return null;
  const fmt = (n) => Number(n || 0).toLocaleString("es-PY", { maximumFractionDigits: moneda === "PYG" ? 0 : 2 });
  const items = res.items || [];
  const total = Number(res.total_retencion || 0);
  const bruto = items.reduce((s, i) => s + Number(i.monto_bruto || 0), 0);
  const motivo = items.find(i => MOTIVOS[i.motivo])?.motivo;

  return (
    <div className="rounded-lg border border-amber-500/30 bg-amber-500/5 p-3 text-xs space-y-1">
      <p className="text-amber-300 font-medium">Retención de IVA (agente de retención)</p>
      {total > 0 ? (
        <>
          <div className="flex justify-between text-slate-300"><span>Importe aplicado a la deuda</span><span>{fmt(bruto)}</span></div>
          {items.map((i, k) => (
            <div key={k} className="text-slate-400 flex justify-between">
              <span>Base s/IVA {fmt(i.base)} · IVA {fmt(i.iva)}{i.pct ? ` · ${i.pct}%` : ""}</span>
              <span>- {fmt(i.monto_retencion)}</span>
            </div>
          ))}
          <div className="flex justify-between text-white font-medium border-t border-white/10 pt-1">
            <span>Retención total</span><span>- {fmt(total)}</span>
          </div>
          <div className="flex justify-between text-emerald-300 font-medium">
            <span>Neto a pagar (sale de la cuenta)</span><span>{fmt(bruto - total)}</span>
          </div>
        </>
      ) : (
        <p className="text-slate-400">{MOTIVOS[motivo] || "Sin retención en este pago"}.</p>
      )}
      {onOmitir && (
        <label className="flex items-start gap-2 pt-1 text-slate-300 cursor-pointer">
          <input type="checkbox" className="mt-0.5" checked={!!omitir} onChange={e => onOmitir(e.target.checked)} />
          <span>No aplicar retención en este pago (el proveedor cobró el importe completo)</span>
        </label>
      )}
    </div>
  );
}
